import axios from "axios";
import LocalStorage from "../../localStorage";
import {loggedOut} from "../auth";

export const GET_PIM_STATUS_REQUEST = 'GET_PIM_STATUS_REQUEST';
export const GET_PIM_STATUS_SUCCESS = 'GET_PIM_STATUS_SUCCESS';
export const GET_PIM_STATUS_FAILURE = 'GET_PIM_STATUS_FAILURE';

const localStorageService = LocalStorage.getService();

export const getPimStatusRequest = () => {
    return {type: GET_PIM_STATUS_REQUEST}
};

export const getPimStatusSuccess = (pim_status = {}) => {
    return {type: GET_PIM_STATUS_SUCCESS, pim_status}
};

export const getPimStatusFailure = (error) => {
    return {type: GET_PIM_STATUS_FAILURE, error}
};

export const startGetPimStatus = () => {
    console.log('Start startGetPimStatus');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getPimStatusRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/pim_status/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response pim_status search ", response.data);
                    dispatch(getPimStatusSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getPimStatusFailure(error));
            });
    };
};
